import { createFileRoute } from "@tanstack/react-router";
import { ForCouplesComponent } from "@/pages/for-couples";
import { head, loader } from "@/pages/for-couples.meta";

export const Route = createFileRoute("/$locale/for-couples")({
  loader,
  head,
  component: ForCouplesComponent,
});
